// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.not-found .breadcrumb-vue[data-v-28119fb0] {\n\t\tmargin: 0px !important;\n}\n.is-auth[data-v-28119fb0] {\n\t\theight: 400px;\n\t\twidth: 400px;\n\t\tmargin: auto;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tright: 0;\n\t\tleft: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
